module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/user/user-create/user-create.component.scss
// module id = ./src/app/user/user-create/user-create.component.scss
// module chunks = main